import Cookies from 'js-cookie';

export const useCookie = <T>(name: string): T | undefined => {
  const cookieValue = Cookies.get(name);
  if (!cookieValue) return undefined;
  return cookieValue as T;
};
